import React, { Component, Fragment } from "react";
import Navbar from "../../Components/ProducaoSTI/Realizado/UI/Navbar";
import UploadIndex from "../../Components/ProducaoSTI/Realizado/Upload/Index";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioSTI from "./menuRelatorioSTI";

export default class PageUpload extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <UploadIndex />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}